import React, { useContext } from "react";
import styled, {ThemeContext} from "styled-components";
import { Header as _Header, Paragraph as _Paragraph } from "../../components/atoms";

const WhoWeAre = () => {

    const theme = useContext(ThemeContext)

    return <Wrapper>
        
        <TextContainer>
            <Header size={30}>Our Story</Header>
            <Paragraph>Our founding team has spent a decade building digital products for blue chip companies to improve workplace health and safety, recruitment efficiency and human capital management. After launching a number of successful apps for clients, we decided we would develop our own.</Paragraph>
            <Paragraph>In 2019, we began looking at challenges that remote workers are faced with in safety-critical environments in the construction and rail sectors. As we launched in early 2020, the COVID-19 pandemic and the global increase in remote working led us to where we are today - developing Digital PPE for all types of organisation at a time when the health, safety and wellbeing of workers has never been more important.</Paragraph>
        </TextContainer>
        <Spacer/>
        <ImageContainer>
            <Image src={theme.img.about1}/>
        </ImageContainer>
        <VerticalSpacer/>
        <LastImageContainer>
            <Image src={theme.img.about2}/>
        </LastImageContainer>
        <TextContainer>
            <Header size={30}>Digital PPE</Header>
            <Paragraph>Every organisation has a duty of care to ensure their workplace is safe and free from unnecessary risks. Before the COVID-19 pandemic, PPE was a term generally reserved for safety-critical environments. Now, it is commonplace everywhere from supermarkets to the kitchen at home. In a world with mobile technology at the disposal of almost all working professionals, we believe Personal Protective Equipment now goes beyond hard hats, boots and gloves.</Paragraph>
            <Paragraph>Our aim is to become the global leader in self-service Digital PPE. No matter your organisation’s size, industry, location or budget, we aim to provide an out-of-the-box tool to enhance the health, safety and wellbeing of your people.</Paragraph>
        </TextContainer>

    </Wrapper>
}

export default WhoWeAre

const Wrapper = styled.div`
    padding: 100px;
    margin: 0px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    max-width: 1100px;

    @media only screen and (max-width: 1250px) {
        flex-direction: column;
        flex-wrap: nowrap;
        padding: 20px;
    }

    @media only screen and (max-width: 750px) {
        max-width: 100vw;
    }
`

const Header = styled(_Header)`
    text-align: left;
    margin-bottom: 20px;
`

const Paragraph = styled(_Paragraph)`
    max-width: 500px;
    text-align: left;
`

const TextContainer = styled.div`
    margin: auto 0px;
`

const Spacer = styled.div`
    width: 40px;
`

const VerticalSpacer = styled.div`
    width: 100vw;
    height: 120px;

    @media only screen and (max-width: 1250px) {
        height: 0px;
    }
`

const ImageContainer = styled.div`
    
    text-align: left;
    max-width: 500px;
    max-height: 500px;
    width: 100%;
    
    @media only screen and (max-width: 1250px) {
        margin-top: 40px;
        margin-bottom: 120px;
    }
`

const LastImageContainer = styled(ImageContainer)`
    @media only screen and (max-width: 1250px) {
        order: 100
    }
`

const Image = styled.img`
    
    max-width: 100%;
    max-height: inherit;
    border-radius: 10px;
    box-shadow: 50px 50px ${props => props.theme.color.primaryTransparent};
    object-fit: contain;
`